import type { OwnedTenant } from '../hooks/useOwnedTenants';

/**
 * House picker for owners of multiple auction houses. Renders NOTHING when
 * the user owns 0 or 1 tenants — the overwhelming majority — so single-house
 * owners never see multi-tenant chrome (no ghost features). Pairs with
 * useOwnedTenants; the admin settings pages re-scope their reads/writes to
 * the selected house (review finding #9).
 */
export function HouseSelector({
  tenants,
  selectedId,
  onSelect,
  disabled,
}: {
  tenants: OwnedTenant[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  disabled?: boolean;
}) {
  if (tenants.length < 2) return null;

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.6rem',
        marginBottom: '1rem',
        fontSize: '0.9rem',
      }}
    >
      <span style={{ fontWeight: 500, color: 'var(--text)' }}>Auction house</span>
      <select
        value={selectedId ?? ''}
        onChange={(e) => onSelect(e.target.value)}
        disabled={disabled}
        style={{
          padding: '0.45rem 0.6rem',
          fontSize: '0.9rem',
          color: 'var(--text)',
          background: 'var(--surface)',
          border: '1px solid var(--admin-hairline, var(--border))',
          borderRadius: 'var(--r-tile, 0.375rem)',
        }}
      >
        {tenants.map((t) => (
          <option key={t.id} value={t.id}>
            {t.display_name ?? t.name}
          </option>
        ))}
      </select>
    </label>
  );
}
